import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BeatLoader from 'react-spinners/BeatLoader';

const SingleResult = ({ result }: any) => {
  return (
    <StyledLink to={`/edit-range/form/${result.Name}`}>
      {result.Shooting_Facility_Range_Name__c}
    </StyledLink>
  );
};

const FindRange = () => {
  const [results, setResults] = useState();
  const [loading, setLoading] = useState(false);
  const [searchVal, setSearchVal] = useState();
  const getSearch = (event: any) => {
    event.preventDefault();
    setLoading(true);
    fetch(
      `https://www.wheretoshoot.org/wp-json/search-form/v1/form/${searchVal.replace(
        ' ',
        '+'
      )}`
    )
      .then((res: any) => res.json())
      .then((result: any) => {
        console.log('result', result);
        setLoading(false);
        setResults(result);
      });
  };
  const handleChange = (change: any) => {
    const { value } = change.target;
    setSearchVal(value);
  };

  return (
    <>
      <HeaderText>
        Please enter any part of your range name to display matching records.
      </HeaderText>
      <Form>
        <input
          type="text"
          className="form-control form-control-lg"
          placeholder="Search"
          onChange={handleChange}
          value={searchVal}
        />
        {loading === false && (
          <button type="submit" onClick={getSearch}>
            Search
          </button>
        )}
      </Form>
      {loading && (
        <Div>
          <p>Loading...</p>
          <BeatLoader color="#4a6568" size={30} margin={10} />
        </Div>
      )}
      {results && results.length === 0 && (
        <Wrapper>
          <SubHeaderText>
            Don't see your range? Please double check your listing on{' '}
            <a href="https://www.wheretoshoot.org" target="_blank" rel="noopener noreferrer">
              WhereToShoot.org
            </a>{' '}
            to be sure it has been submitted. You can then search here again to
            modify your record.
          </SubHeaderText>
          <SubHeaderText>
            If you don't see your range in those results you can either submit
            them{' '}
            <a
              href="https://www.wheretoshoot.org/list-your-range/"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{' '}
            or contact Ann Gamauf at{' '}
            <a href="mailto:agamauf@nssf.org">agamauf@nssf.org</a> for
            assistance. Please provide your range name, zip code, email and
            business phone number.
          </SubHeaderText>
        </Wrapper>
      )}
      {results && results.length > 0 && (
        <Wrapper>
          {results.map((single: any) => (
            <SingleResult result={single} key={single.Name} />
          ))}
        </Wrapper>
      )}
    </>
  );
};

export default FindRange;

const Form = styled.form`
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;

  input[type='text'] {
    max-width: 300px;
    margin-right: 10px;
    border: 1px solid;
  }

  button {
    height: 36px;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const Div = styled.div`
  height: 40vh;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  p {
    width: 100%;
    text-align: center;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1170px;
  margin: auto;

  p {
    width: 100%;
    text-align: center;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: block;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
`;

const HeaderText = styled.h3`
  text-align: center;
  margin-top: 30px !important;
`;

const SubHeaderText = styled.p`
  text-align: center;
  line-height: 1.3;
  margin: 0 0 10px;
`;
